(() => {
  const rules = [
    { sel: 'h2.complementary-products__heading', add: ['h2'] },
    { sel: 'h4.foxkit-cartgoal__title',           add: ['h4'] },
    { sel: '#insta-feed > h2',                   add: ['h2'] },
    { sel: 'quick-view-modal h1.product__title', add: ['h1'] }, 
    { sel: 'h2.jdgm-rev-widg__title',            add: ['h2'] },
    { sel: 'h3.f-quantity-breaks__heading',      add: ['h3'] },
    { sel: 'h4.f-quantity-breaks__card-title',   add: ['h4'] },
  ];

  const DONE = 'data-h-to-span-done';

  const toSpan = (el, addClasses = []) => {
    if (!el || el.hasAttribute(DONE)) return;

    const span = document.createElement('span');

    // copy attributes
    for (const { name, value } of [...el.attributes]) span.setAttribute(name, value);

    // add extra classes (e.g. h2/h3/h4)
    addClasses.forEach(c => span.classList.add(c));

    // mark done
    span.setAttribute(DONE, '1');

    // keep content
    span.innerHTML = el.innerHTML;

    el.replaceWith(span);
  };

  const run = () => {
    for (const r of rules) {
      document.querySelectorAll(r.sel).forEach(el => toSpan(el, r.add));
    }
  };

  run();

  const obs = new MutationObserver(run);
  obs.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', run);
})();